import React, {Component} from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button/index";
import Typography from "@material-ui/core/Typography/index";
import {Color} from './../utis/Styles'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import {languagePackage} from "../utis/localStrings"

class Consent extends Component {
	constructor(props) {
		super(props)
		this.state = {
			role: 'dr'
		}
	}

	handleChange (event) {
		let value = event.target.value
		this.setState({role: value})
	}

	renderRoleView() {
		return (
			<FormControl component="fieldset">
				<FormLabel component="legend">Your role ?</FormLabel>
				<RadioGroup aria-label="gender" name="gender1" value={this.state.role} onChange={(event) => {
					this.handleChange(event)
				}}>
					<FormControlLabel value={'dr'} control={<Radio />} label="I'm Doctor" />
					<FormControlLabel value={'pt'} control={<Radio />} label="I'm Patient" />
				</RadioGroup>
			</FormControl>
		);
	}
	render() {
		const { classes } = this.props
		return(
			<div className={classes.root}>
				<div className={classes.attentionBgView}>
					<Typography className={classes.attention} variant="body1" gutterBottom>
						{languagePackage().OpenUrlInBrowserTips}
					</Typography>
				</div>
				<div className={classes.container}>
					<div className={classes.agreementContainer}>
						<Typography className={classes.agreementTitle} variant="h6" gutterBottom>
							{languagePackage().TeleHealthConsent}
						</Typography>

						<Typography className={classes.agreement} variant="body1" gutterBottom>
							{languagePackage().TelehealthAgreement1}
						</Typography>

						<Typography className={classes.agreement} variant="body1" gutterBottom>
							{languagePackage().TelehealthAgreement2}
						</Typography>

						<Typography className={classes.agreement} variant="body1" gutterBottom>
							{languagePackage().TelehealthAgreement3}
						</Typography>

						<Typography className={classes.agreement} variant="body1" gutterBottom>
							{languagePackage().TelehealthAgreement4}
						</Typography>

						<Typography className={classes.agreement} variant="body1" gutterBottom>
							{languagePackage().TelehealthAgreement5}
						</Typography>

						<div className={classes.agreeButtonContainer}>
							<Button onClick={() => {
								let isPatientRole = (this.state.role === 'pt')
								this.props.signAction && this.props.signAction(isPatientRole)
							}} className={classes.agreeButton} color="default">
								{languagePackage().Accept}
							</Button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const styles = (theme) => ({
	root: {
		width: '100%',
		height: '100%',
		backgroundColor: Color.white,
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
	},
	container: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: 90
	},
	agreementContainer: {

	},
	agreeButtonContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		marginTop: 16,
	},
	agreeButton: {
		height: 50,
		width: 150,
		marginBottom: 50,
		color: Color.white,
		backgroundColor: Color.theme,
		fontSize: 18
	},
	agreementTitle: {
		marginLeft: 16,
		marginTop: 16,
		marginRight: 16,
		fontWeight: 'bold',
		textAlign: 'center',
		fontSize: 20
	},
	agreement: {
		marginLeft: 16,
		marginTop: 16,
		marginRight: 16,
		fontSize: 16
	},
	installBar: {
		width: '100%',
		position: 'absolute',
		left: 0,
		top: 0,
	},
	attentionBgView: {
		backgroundColor: Color.systemGray,
		width: '100%',
		paddingTop: 10,
		paddingBottom: 10,
		position: 'fixed',
		left: 0,
		top: 0,
	},
	attention: {
		marginLeft: 16,
		marginRight: 16,
		textAlign: 'center',
		fontSize: 18,
		color: Color.red,
		fontWeight: 'bold'
	},
})

export default withStyles(styles)(Consent)
